// TODO: initialize and export a standard bytewise encoding, add hex and binary
module.exports = require('./encoding/')



//////////////////
// WEBPACK FOOTER
// ./node_modules/bytewise/index.js
// module id = U0+g
// module chunks = 70